import React from 'react';

import { NoResults } from '@gogame/components';
import { withForm, SidePageV2 } from '@gogame/form';

import { LEFT_DRAWER_Z_INDEX } from '../../App/components/Sidebar/constants';
import NotificationSettingsItem from './NotificationSettingsItem';
import { notificationsSettingsSchema } from './schema';

const NotificationsSettingsForm = withForm({
  enableReinitialize: true,
  validationSchema: notificationsSettingsSchema,
})(({ onClose, loading, onExited, open, values, errors }) => {
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      width={800}
      direction={'right'}
      directionOfset={'64px'}
      zIndex={LEFT_DRAWER_Z_INDEX}
    >
      <SidePageV2.Title title={'Notifications Settings'} />
      <SidePageV2.Content>
        {values?.eventGroups?.length ? (
          values.eventGroups.map((group, i) => {
            return (
              <NotificationSettingsItem
                name={`eventGroups.${i}`}
                errors={errors}
                group={group}
                index={i}
                key={i}
              />
            );
          })
        ) : (
          <NoResults inited={!!values?.eventGroups} />
        )}
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default NotificationsSettingsForm;
